export default "__VITE_ASSET__CtRsw9kX__"